/* AJA storefront extras: cart recommendations + free shipping progress bar.
   Loaded from layout/theme.liquid so the custom elements are always defined,
   even when the cart starts empty and sections arrive via innerHTML. */

(function () {
  /* ---- free shipping progress bar fill animation ---- */
  if (!customElements.get('free-ship-fill')) {
    customElements.define(
      'free-ship-fill',
      class extends HTMLElement {
        connectedCallback() {
          /* The fill width is fully server-rendered by Liquid — JS deliberately
             never touches it, so the bar is always correct even with throttled
             timers or blocked scripts. */
        }
      }
    );
  }

  /* ---- cart drawer / cart page recommendations ---- */
  if (!customElements.get('cart-recommendations')) {
    class CartRecommendations extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.load().catch(function () {
          self.remove();
        });
      }

      formatMoney(cents) {
        var fmt = this.dataset.moneyFormat || 'LE {{amount}}';
        var textarea = document.createElement('textarea');
        textarea.innerHTML = fmt;
        fmt = textarea.value;
        var pattern = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}');
        var m = fmt.match(pattern);
        var key = m ? m[1] : 'amount';
        var value =
          key.indexOf('no_decimals') >= 0 ? Math.round(cents / 100).toString() : (cents / 100).toFixed(2);
        return fmt.replace(pattern, value);
      }

      async fetchRecs(intent) {
        var url =
          this.dataset.recsUrl + '.json?product_id=' + this.dataset.productId + '&limit=6&intent=' + intent;
        var res = await fetch(url);
        if (!res.ok) return [];
        var body = await res.json();
        return body.products || [];
      }

      async load() {
        var inCart = this.dataset.inCart.split(',').map(Number);
        var products = await this.fetchRecs('complementary');
        if (!products.length) products = await this.fetchRecs('related');
        products = products
          .filter(function (p) {
            return p.available && inCart.indexOf(p.id) === -1;
          })
          .slice(0, 2);
        if (!products.length) {
          this.remove();
          return;
        }
        var list = this.querySelector('.cart-recs__list');
        list.innerHTML = '';
        products.forEach(this.renderItem.bind(this, list));
        this.querySelector('.cart-recs__inner').hidden = false;
      }

      renderItem(list, product) {
        var self = this;
        var item = document.createElement('div');
        item.className = 'cart-recs__item';

        var img = document.createElement('img');
        img.loading = 'lazy';
        img.width = 56;
        img.height = 70;
        if (product.featured_image) {
          img.src =
            product.featured_image + (product.featured_image.indexOf('?') >= 0 ? '&' : '?') + 'width=120';
        }
        item.appendChild(img);

        var info = document.createElement('div');
        var link = document.createElement('a');
        link.className = 'cart-recs__title';
        link.href = product.url;
        link.textContent = product.title;
        var price = document.createElement('p');
        price.className = 'cart-recs__price';
        price.textContent = this.formatMoney(product.price);
        info.appendChild(link);
        info.appendChild(price);
        item.appendChild(info);

        var actions = document.createElement('div');
        actions.className = 'cart-recs__actions';
        var available = (product.variants || []).filter(function (v) {
          return v.available;
        });
        var select = null;
        if (available.length > 1) {
          select = document.createElement('select');
          select.className = 'cart-recs__size';
          select.setAttribute('aria-label', 'Size');
          available.forEach(function (v) {
            var opt = document.createElement('option');
            opt.value = v.id;
            opt.textContent = v.title;
            select.appendChild(opt);
          });
          actions.appendChild(select);
        }
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cart-recs__add';
        btn.textContent = 'Add';
        btn.addEventListener('click', function () {
          var variantId = select ? select.value : available[0] && available[0].id;
          if (!variantId) return;
          btn.disabled = true;
          self.addToCart(variantId).catch(function () {
            btn.disabled = false;
          });
        });
        actions.appendChild(btn);
        item.appendChild(actions);

        list.appendChild(item);
      }

      async addToCart(variantId) {
        var cartDrawer = document.querySelector('cart-drawer');
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        if (cartDrawer && cartDrawer.getSectionsToRender) {
          var sections = cartDrawer.getSectionsToRender().map(function (s) {
            return s.section || s.id;
          });
          fd.append('sections', sections.join(','));
          fd.append('sections_url', window.location.pathname);
        }
        var res = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd,
        });
        if (!res.ok) throw new Error('add failed');
        var json = await res.json();
        if (cartDrawer && cartDrawer.renderContents) {
          cartDrawer.renderContents(json);
        } else {
          window.location.reload();
        }
      }
    }
    customElements.define('cart-recommendations', CartRecommendations);
  }
})();
